import { render, staticRenderFns } from "./LoadingList.vue?vue&type=template&id=c2aeebae&scoped=true"
import script from "./LoadingList.vue?vue&type=script&lang=js"
export * from "./LoadingList.vue?vue&type=script&lang=js"
import style0 from "./LoadingList.vue?vue&type=style&index=0&id=c2aeebae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aeebae",
  null
  
)

export default component.exports